
  import { Component, Watch } from 'vue-property-decorator'
  import BaseForm from '@/components/forms/view/BaseForm.vue'
  import LinkedAuto from '@/components/forms/fields/LinkedAuto.vue'
  import { plainToInstance } from 'class-transformer'
  import { Form } from '@/entities/public/Resource/metadata'
  import { Deal, Lead } from '@/entities/crm'
  import InitialFields from '@/components/forms/fields/InitialFields.vue'
  import LinkedPerson from '@/components/forms/fields/LinkedPerson.vue'
  import FieldTitle from '@/components/forms/fields/FieldTitle.vue'
  import StockPrices from '@/components/toolkit/details/row/custom/StockPrices.vue'
  import AutoHeader from '@/components/toolkit/details/row/expandable/auto/header.vue'
  import Simple from '@/components/toolkit/details/row/simple.vue'
  import GFiles from '@/components/core/files/GFiles.vue'
  import { Process } from '@/entities/settings'
  import { fixPrice, isValidNumber, nameAlert, parseToNumber, stringifySafe, updateNestedObject } from '@/utils/general'
  import { Payment, PaymentOrder } from '@/entities/finance'
  import GAlert from '@/components/core/alert/GAlert.vue'
  import GLoading from '@/components/core/GLoading.vue'
  import logOut from '@/components/LogOut.vue'
  import { ItemType, SaleOrder, SaleOrderItem } from '@/entities/sales'
  import { SaleOrderView } from '@/components/forms/view/SaleOrderView'
  import GCostField from '@/components/core/input/GCostField.vue'
  import GDatePicker from '@/components/core/input/GDatePicker.vue'
  import Agenda from '@/components/forms/fields/agenda/Agenda.vue'
  import GRadioButton from '@/components/core/input/GRadioButton.vue'
  import { Debounce } from '@/utils/decorators'
  import { Person } from '@/entities/persons'
  import { ProcessTrafficTicket } from '@/entities/purchase'
  import ProgressCell from '@/components/dataTables/cell/ProgressCell.vue'
  import { Offer } from '@/entities/loans'
  import ValidationPaymentComponent from '@/components/forms/validationSaleOrder/validationPaymentComponent.vue'
  import AutoResume from '@/components/forms/AutoResume.vue'
  import GTextarea from '@/components/core/input/GTextarea.vue'
  import { ValidationStatus, FormValidationItem } from '@/entities/entity'
  import SalePDFCell from '@/components/dataTables/cell/salePDFCell.vue'

@Component({
  components: {
    GTextarea,
    AutoResume,
    ProgressCell,
    GRadioButton,
    Agenda,
    GDatePicker,
    GCostField,
    logOut,
    GLoading,
    GAlert,
    GFiles,
    Simple,
    StockPrices,
    FieldTitle,
    LinkedPerson,
    InitialFields,
    LinkedAuto,
    BaseForm,
    AutoHeader,
    ValidationPaymentComponent,
    SalePDFCell,
  },
  methods: {
    fixPrice,
  },
})
  export default class SaleOrderForm extends SaleOrderView {
  declare $refs: {
    salePDFCell: SalePDFCell,
    form: HTMLFormElement,
    fieldClient: LinkedPerson,
    fieldAcquirer: LinkedPerson,
    fieldSigners: LinkedPerson,
  }

  loadingNote = false
  loaded = false
  transferCost = 0
  documentId = null
  suggestedTransferCost = 0
  deal = plainToInstance(Deal, {})
  payments: Array<Payment> = []
  lead = plainToInstance(Lead, {})
  saleOrder = plainToInstance(SaleOrder, {})
  saleOrderProcess = null
  isDirectSale = false
  process: Process = plainToInstance(Process, {})
  paymentOrder: PaymentOrder = plainToInstance(PaymentOrder, {})
  minValue = null
  maxDays = null
  newAgenda = null
  activity = null
  digitalContractLink = ''
  isMultiple = false
  activities = []
  viewDetails = null
  currencyExchanges = {}
  penalties: ProcessTrafficTicket[] = []
  penaltiesErrorMessage = ''
  purchase = {
    open: false,
    title: '',
    item: null,
  }

  saleOrderItemDiscountId = null
  products = []
  errorDiscount = ''
  errorSignerMessages = ''
  rutError = ''
  errorAcquirerMessages = ''
  errorMessages = ''
  errorDiscountPostFinancing = ''
  warrantyAmountSet = 0
  saleMetadata = null
  disabledDocumentType = null
  discountPostFinancing = 0
  title = ''
  idProcess = null
  showDetail = false
  fileInfo = null
  panels = [0]
  section = {
    interviews: false,
    documents: false,
    payment: false,
  }

  warrantyAmount = null
  metadata = {}
  formData = {
    client: null,
    observation: null,
    discountPostFinancing: null,
    discount: null,
    order: null,
    isWarranty: null,
    insurance: null,
    broker: null,
    isTag: null,
    deductible: null,
    cost: null,
    warranty: null,
    transferCost: null,
    signers: null,
    acquirer: null,
    documentType: null,
    fileWarranty: [],
    comment: null,
    fileExtraWarranty: [],
    fileTag: [],
    fileCav: [],
    filePenalties: [],
    fileLicense: [],
    fileLegalReport: [],
    linkLegalReport: null,
    contract: [],
    linkContract: null,
    saleOrderSigned: [],
  }

  fields = {
    warranties: {
      properties: {
        label: 'Garantia',
        required: true,
        itemText: 'warrantyDescription',
        itemValue: 'id',
        rules: [],
      },
      items: [],
      rules: [],
    },
    deductible: {
      properties: {
        label: 'Deducible',
        required: true,
        itemText: 'description',
        itemValue: 'id',
        rules: [],
      },
      items: [],
      rules: [],
    },
    insurance: {
      properties: {
        label: 'Compañia de seguros',
        required: true,
        rules: [],
        itemText: 'alias',
        itemValue: 'id',
        returnObject: true,
      },
      items: [],
      rules: [],
    },
    brokers: {
      properties: {
        label: 'Corredora de seguros',
        required: true,
        rules: [],
        itemText: 'alias',
        itemValue: 'id',
        returnObject: true,
      },
      items: [],
      rules: [],
    },
    client: {
      properties: {
        required: true,
        disabled: true,
        properties: {
          label: 'Cliente',
          rules: [],
          itemText: 'formInfo',
          itemValue: 'id',
          returnObject: true,
        },
      },
      items: [],
      rules: [],
    },
    acquirer: {
      properties: {},
      items: [],
      rules: [],
    },
    signers: {
      properties: {},
      items: [],
      rules: [],
    },
    documentType: {
      properties: {},
      rules: null,
      items: [],
    },
    linkContract: {
      properties: {
        required: true,
      },
    },
    linkLegalReport: {
      properties: {},
    },
    order: {
      properties: {
        label: 'Abonos',
        required: true,
        readOnly: true,
        rules: [],
        appendOuterIcon: '',
      },
    },
  }

  disabledFormSelection = {
    warranty: false,
    tag: false,
  }

  paymentSelected: number = undefined
  openPayment: boolean = false
  paymentPending: string = ''

  async mounted () {
    this.loadingForm = true
    await this.setMetadata()
    const { id, uid, model, title, saleMetadata } = this

    if ((!isNaN(uid) && (model === 'SaleOrder' || model === '')) || !isNaN(id)) {
      const saleId = id || uid
      await this.getSellInfo(saleId)
    }

    if (!this.isBreadCrumbPresent(title)) {
      this.setFormCrumbs(saleMetadata, title, Boolean(this.saleOrder?.id))
    }

    await this.setTheBackup()
    this.setDetails()
    this.loadingForm = false
  }

  async setTheBackup () {
    const { backup } = this
    if (!backup) return
    const saleForm = 'saleForm' in backup && backup.saleForm

    if (saleForm) {
      this.formData = backup.saleForm
      this.panels = backup.saleForm.panels
    }

    this.formData.order = await this.fetchData({
      query: { name: 'find', model: 'Payment' },
      filter: {
        _and: [
          { id_deal: { _eq: this.saleOrder?.deal?.id } },
          { _or: [{ id_closing_reason: { _is_null: true } }, { closing_reason: { type: { name: { _neq: 'canceled' } } } }] },
        ],
      },
      force: true,
    })
    this.setPersons(backup)
  }

  setPersons (backup) {
    if ('acquirer' in backup && backup.acquirer) {
      const backupAcquirer = backup.saleForm?.acquirer || []
      const acquirers = [backup.acquirer, ...backupAcquirer?.filter(acquirer => acquirer.id !== backup.acquirer.id)].filter(Boolean)
      this.formData.acquirer = acquirers
      this.fields.acquirer.items = acquirers
    }

    if ('signers' in backup && backup.signers) {
      const backupSigners = backup.saleForm?.signers || []
      const signers = [backup.signers, ...backupSigners?.filter(signer => signer.id !== backup.signers.id)].filter(Boolean)
      this.formData.signers = signers
      this.fields.signers.items = signers
    }
  }

  cancelSale () {
    const { formData: { fileCav, fileLicense, filePenalties, fileExtraWarranty, fileWarranty, fileTag, contract } } = this
    this.setBackup(null)
    const files = [...fileCav, ...fileLicense, ...filePenalties, ...fileExtraWarranty, ...fileWarranty, ...fileTag, ...contract]

    this.close(files)
  }

  openOrder (item) {
    this.paymentSelected = item
    this.openPayment = true
    this.paymentPending = ''
  }

  async getSellInfo (id) {
    this.saleOrder = await this.fetchData({
      query: { name: 'fetch', model: 'SaleOrder', params: { id } },
      force: true,
    })

    const lead = await this.fetchData({
      query: { name: 'fetch', model: 'Lead', params: { id: this.saleOrder?.deal?.lead?.id } },
      force: true,
    })

    const idDeal = this.saleOrder?.deal?.id

    this.formData.order = await this.fetchData({
      query: { name: 'find', model: 'Payment' },
      filter: {
        _and: [
          { id_deal: { _eq: idDeal } },
          { _or: [{ id_closing_reason: { _is_null: true } }, { closing_reason: { type: { name: { _neq: 'canceled' } } } }] },
        ],
      },
      force: true,
    })

    const acquirers = this.saleOrder.document?.acquirers?.length ? this.saleOrder.document?.acquirers : this.saleOrder?.deal?.stock?.acquirer
    this.formData.acquirer = acquirers
    this.fields.acquirer.items = acquirers?.length ? acquirers : [lead.client]
    this.formData.observation = this.saleOrder?.observation
    await this.getAdditionalInfo()
    this.suggestedTransferCost = await this.calculateTransfer(this.saleOrder?.deal?.stock?.id)
    if (!this.saleOrder?.saleOrderItems?.find(item => item?.type?.name === 'transfer')) {
      this.transferCost = this.suggestedTransferCost
    } else {
      this.transferCost = this.saleOrder?.saleOrderItems?.find(item => item?.type?.name === 'transfer')?.amount
    }

    this.formData.transferCost = this.transferCost
    this.saleOrder.deal.lead = lead
    const { sale: { order: { discount } } } = lead
    this.setLeadInfo(lead, discount)
  }

  async getAdditionalInfo () {
    this.fields.insurance.items = await this.fetchData({
      query: { name: 'find', model: 'Person' },
      filter: { company_type: { name: { _eq: 'insurance_carrier' } } },
      limit: 100,
    })
    const brokers = await this.fetchData({
      query: { name: 'find', model: 'Person' },
      filter: { company_type: { name: { _eq: 'broker' } } },
    })

    this.fields.brokers.items = brokers
    const deductibles = await this.fetchData({
      query: { name: 'find', model: 'DeductibleType' },
    })
    this.fields.deductible.items = deductibles
    const products = await this.fetchData({
      query: { name: 'find', model: 'SaleProduct' },
      filter: { id_sale_order: { _eq: this.saleOrder.id } },
      force: true,
    })

    const insurance = products?.find(product => product.name === 'insurance')
    this.formData.insurance = this.fields.insurance.items?.find(insuranc => insuranc.id === insurance?.company?.id)
    this.formData.broker = brokers?.find(broker => broker.id === insurance?.broker?.id) || plainToInstance(Person, {
      id: null,
      alias: 'Ninguna',
    })
    this.formData.cost = insurance?.cost
    this.formData.deductible = deductibles?.find(deductible => deductible.id === insurance?.deductible?.id)?.id

    const tag = products?.find(product => product.name === 'tag')

    const warranty = products?.find(product => product.name === 'warranty')
    this.warrantyAmountSet = warranty?.cost

    if (tag) {
      this.formData.isTag = true
    } else if (insurance) {
      this.formData.isTag = false
    }
    this.products = products || []

    const supports = await this.fetchData({
      query: { name: 'find', model: 'SupportDocumentType' },
    })

    this.fields.documentType.items = supports
    this.formData.documentType = supports.find(support => support.name === this.saleOrder?.stockDocumentType)
    await this.setFiles(tag, products?.find(product => product.name === 'warranty'))
    await this.stockInfo()
  }

  async stockInfo () {
    const { saleOrder } = this

    const view = (await this.fetchData({
      query: { name: 'find', model: 'StockViewDetails' },
      filter: {
        id_stock: { _eq: saleOrder?.deal?.stock?.id },
      },
    }))[0]
    this.viewDetails = view

    this.disabledDocumentType = view?.documentType?.name === 'invoice_affect'
    const process = (await this.fetchData({
      query: { name: 'find', model: 'Process' },
      filter: { table_name: { _eq: 'purchase_order' } },
    }))[0]

    const files = await this.fetchData({
      query: { name: 'find', model: 'FileProcess' },
      filter: {
        _and: [
          { id_process_record: { _eq: view.idPurchase } },
          { parameter: { process: { id: { _eq: process.id } } } },
        ],
      },
      force: true,
    })

    this.digitalContractLink = files.find(file => file.parameter.name === 'digital_contract')?.file?.sourceLink
    if (!this.saleOrder?.stockDocumentType) {
      this.formData.documentType = view?.documentType
    }

    if (!this.formData.linkContract?.length) {
      this.formData.linkContract = this.digitalContractLink
    }
  }

  async setOffers (offers) {
    for (const item of offers) {
      if (item.quotas.length) {
        try {
          const exchangeValue = await this.getCurrencyValueExchange(item.quotas[0], this.currency)
          this.$set(this.currencyExchanges, item.id, fixPrice(exchangeValue))
        } catch (error) {
          console.error(error)
          this.$set(this.currencyExchanges, item.id, 'Error')
        }
      }
    }
    this.fields.warranties.items = offers
    if (this.saleOrderProcess?.config?.warranty?.formWithoutWarranty) {
      this.fields.warranties.items.unshift(plainToInstance(Offer, { id: null }))
    }
  }

  async setFiles (tag, warranty) {
    const { filesProcess: { saleProduct } } = this

    const offers = await this.fetchData({
      query: { name: 'find', model: 'Offer' },
      filter: {
        variant: {
          _and: [
            {
              agreement_product: {
                _and: [
                  { product: { name: { _eq: 'warranty' } } },
                  { active: { _eq: true } },
                ],
              },
            },
            { active: { _eq: true } },
          ],
        },
      },
      force: true,
    })

    await this.setOffers(offers)
    if (!this.backup?.saleForm) {
      this.formData.warranty = this.fields.warranties.items.find(item => item.id === warranty?.offer?.id)
    }

    if (this.saleOrderProcess?.config?.warranty?.formWithoutWarranty && !this.saleOrder?.status?.isPending && !this.formData.warranty) {
      this.formData.warranty = this.fields.warranties.items[0]
    }

    this.formData.isWarranty = Boolean(this.formData.warranty && this.formData.insurance)
    this.disabledFormSelection.warranty = this.formData.isWarranty
    this.formData.isTag = this.formData.isTag ?? Boolean(this.formData.warranty?.id && this.formData.fileTag.length)
    this.disabledFormSelection.tag = this.formData.isTag

    this.formData.comment = warranty?.comment
    if (warranty?.id) {
      const warrantyFiles = await this.fetchData({
        query: { name: 'find', model: 'FileProcess' },
        filter: {
          _and: [
            { id_process_record: { _eq: warranty.id } },
            { parameter: { process: { id: { _eq: saleProduct } } } },
          ],
        },
        force: true,
      })
      this.formData.fileWarranty = warrantyFiles.filter(file => file.parameter.name === 'warranty') || []
      this.formData.fileExtraWarranty = warrantyFiles.filter(file => file.parameter.name === 'extra_warranty') || []
    }

    if (tag?.id) {
      const tagFiles = await this.fetchData({
        query: { name: 'find', model: 'FileProcess' },
        filter: {
          _and: [
            { id_process_record: { _eq: tag.id } },
            { parameter: { process: { id: { _eq: saleProduct } } } },
          ],
        },
        force: true,
      })

      this.formData.fileTag = tagFiles.filter(file => file.parameter.name === 'tag') || []
    }
    await this.setFilesData()
  }

  async findAssociatedFiles (idProcess, id) {
    if (!id) return {}
    const { isDigitalContract } = this
    const files = await this.fetchData({
      query: { name: 'find', model: 'FileProcess' },
      filter: {
        _and: [
          { id_process_record: { _eq: id } },
          { parameter: { process: { id: { _eq: idProcess } } } },
        ],
      },
      force: true,
    })

    const cav = files.filter(file => file.parameter.name === 'cav')

    if (cav.length) {
      this.saleOrder.cavValidation = {
        expirationDate: cav[0].file.expirationDate,
        validations: cav[0].validation,
      }
    }

    const report = files.filter(file => file.parameter.name === 'legal_report')

    const penalties = files.filter(file => file.parameter.name === 'penalty_certificate')

    let contract = files.filter(file => !isDigitalContract ? file.parameter.name === 'buyer_physical_contract' : file.parameter.name === 'buyer_digital_contract')
    if (!contract?.length) {
      contract = files.filter(file => file.parameter.name === 'exempt_invoice' || file.parameter.name === 'invoice_affect')
    }

    const buyerCard = files.filter(file => file.parameter.name === 'buyer_card')
    const saleOrderSigned = files.filter(file => file.parameter.name === 'signed_sale_order')

    return {
      cav,
      report,
      contract,
      penalties,
      buyerCard,
      saleOrderSigned,
    }
  }

  get displaySaleOrderSigned () {
    const { totalPercentageValidate, totalPercentagePaid, signers, formData: { documentType } } = this

    const allPaymentsPaid = totalPercentageValidate === '100.00' && totalPercentagePaid === '100.00'
    return signers.length && allPaymentsPaid && documentType?.id
  }

  get changeSaleOrderStatus () {
    const { displaySaleOrderSigned, saleOrder } = this

    if (!displaySaleOrderSigned || !saleOrder) {
      return false
    }

    // Filtrar solo las validaciones que no son opcionales
    const requiredValidations = saleOrder.formValidation.filter(
      validation => validation.value !== ValidationStatus.OPTIONAL
    )

    // Verificar que todas las validaciones requeridas estén en estado OK
    return requiredValidations.every(
      validation => validation.value === ValidationStatus.OK
    ) && displaySaleOrderSigned
  }

  async setFilesData () {
    const {
      cav,
      contract,
      penalties,
      report,
      buyerCard,
      saleOrderSigned,
    } = await this.findAssociatedFiles(this.filesProcess.saleOrder, this.saleOrder.id)

    this.formData.fileCav = cav?.length ? [cav[0]] : []
    this.formData.fileLegalReport = report?.length ? [report[0]] : []
    if (report?.[0]?.file?.sourceLink) {
      this.formData.linkLegalReport = report?.[0]?.file?.sourceLink
    }
    this.formData.contract = contract?.length ? contract : []
    this.formData.saleOrderSigned = saleOrderSigned?.length ? saleOrderSigned : []
    if (contract?.[0]?.file?.sourceLink) {
      this.formData.linkContract = contract?.[0]?.file?.sourceLink
    }
    this.formData.filePenalties = penalties?.length ? [penalties[0]] : []
    this.formData.fileLicense = buyerCard?.length ? [buyerCard[0]] : []
    this.penalties = await this.getPenalties(this.formData?.filePenalties?.[0]?.id)

    const document = await this.fetchData({
      query: { name: 'find', model: 'Document' },
      filter: { id: { _eq: this.saleOrder.documentId } },
      force: true,
    })

    this.documentId = this.saleOrder?.documentId
    this.formData.signers = document[0]?.interveners?.filter(interviner => interviner.field.name === 'purchase_representative').map(intervener => intervener.person) || []
    this.loaded = true
  }

  saveBackup (item = null) {
    const {
      backup,
      formData,
      panels,
      saleOrder: { deal: { lead } },
      saleOrder,
      totalPaymentsPaid,
      totalAmount,
      totalPaymentsValidated,
      totalValid,
      deal,
    } = this

    if (backup) {
      backup.lead = lead
      backup.deal = deal
      backup.saleForm = {
        ...formData,
        panels,
        saleOrder,
        totalPaymentsPaid,
        totalAmount,
        totalPaymentsValidated,
        totalValid,
      }
      backup.editPayment = item
      this.setBackup(backup)
    } else {
      this.setBackup({
        saleForm: {
          ...formData,
          panels,
          saleOrder,
          totalPaymentsPaid,
          totalAmount,
          totalPaymentsValidated,
          totalValid,
        },
        editPayment: item,
        lead,
        deal,
        client: null,
        signers: null,
        acquirer: null,
      })
    }
  }

  async setMetadata () {
    const { metadata } = this.getForm('SaleOrder', 'staff_sale_order')
    const { metadata: metadataReserve } = this.getForm('Reserve', 'reserve')
    const { fields: { config: { init: { value } } } } = metadataReserve as Form
    this.minValue = value.minValue
    this.maxDays = value.maxDays
    const { form, fields: saleFields } = metadata as Form
    this.fields.acquirer.properties = saleFields.acquirer.properties
    this.fields.signers.properties = saleFields.signers.properties
    this.fields.documentType.properties = saleFields.documentType.properties
    this.fields.linkLegalReport.properties = saleFields.linkLegalReport.properties
    this.fields.linkContract.properties = saleFields.linkContract.properties
    this.saleMetadata = metadata
    this.title = form.title

    await this.setFilesFieldsData()
  }

  async setFilesFieldsData () {
    const process = await this.fetchData({
      query: { name: 'find', model: 'Process' },
      filter: { table_name: { _eq: 'sale_order' } },
    })

    const { id } = process[0] as Record<string, any>
    this.isDirectSale = process[0].config?.direct
    this.saleOrderProcess = process[0]
    this.idProcess = id
  }

  @Debounce(500)
  setDetails () {
    const {
      saleMetadata,
      saleOrder,
      formData: { discount, warranty, transferCost: formTransferCost },
      transferCost,
      totalAmount,
      currencyExchanges,
      warrantyAmount,
      warrantyAmountSet,
      viewDetails,
    } = this

    const deal = saleOrder?.deal?.lead?.deals?.find(deal => deal.isSale)
    if (!deal) return

    const pos = deal.saleOrders[0].saleOrderItems.findIndex(item => item.type.name === 'discount')

    if (!pos || pos < 1) {
      deal.saleOrders[0].saleOrderItems.push(plainToInstance(SaleOrderItem, {
        amount: discount,
        type: plainToInstance(ItemType, { id: 2, name: 'discount' }),
      }))
    } else {
      this.saleOrderItemDiscountId = deal.saleOrders[0].saleOrderItems[pos].id
      deal.saleOrders[0].saleOrderItems[pos].amount = discount
    }
    deal.saleOrders[0].status = saleOrder.status
    deal.lead = saleOrder?.deal?.lead
    deal.lead.sale.stock.transferCost = formTransferCost || transferCost
    deal.lead.sale.totalAmount = totalAmount
    deal.lead.sale.order.cavValidation = saleOrder.cavValidation
    deal.lead.sale.warrantyAmount = warrantyAmountSet || currencyExchanges?.[warranty] || fixPrice(warrantyAmount)
    deal.auto = deal.lead.sale.auto
    deal.stock.transferCost = formTransferCost || transferCost
    deal.totalAmount = totalAmount
    deal.warrantyAmount = warrantyAmountSet || currencyExchanges?.[warranty] || fixPrice(warrantyAmount)
    deal.order._discount = discount
    deal.stock.viewDetails = viewDetails

    this.deal = deal
    saleOrder.deal = deal
    this.metadata = {
      data: saleOrder,
      metadata: saleMetadata,
    }

    this.showDetail = (Boolean(saleOrder?.id))
  }

  async preSend () {
    this.panels = [0, 1, 2, 3]

    await this.send()
  }

  checkErrorFileContent () {
    const fields = ['fileCav', 'filePenalties', 'fileLegalReport']

    for (const field of fields) {
      if (this.$refs?.[field]?.errorMessage?.length) {
        return true
      }
    }
  }

  validateFields () {
    const client = this.$refs.fieldClient
    const acquirer = this.$refs.fieldAcquirer
    const signers = this.$refs.fieldSigners
    const rutError = this.rutError?.length
    const overComment = this.formData.comment?.length && this.formData.comment?.length > 250
    const errorMessages = this.errorSignerMessages?.length || this.errorAcquirerMessages?.length || this.checkErrorFileContent()
    const errorDiscount = this.errorDiscount?.length || this.errorDiscountPostFinancing?.length

    if (errorDiscount || this.saleIsApproved || rutError) {
      this.isMultiple = false
      return true
    }
    const { saleOrderToContract } = this

    if (saleOrderToContract && ((acquirer && !acquirer?.$refs.form.validate()) || (signers && !signers?.$refs.form.validate()) || errorMessages)) {
      this.isMultiple = false
      return true
    }

    if (!this.$refs.form.validate() || !client?.$refs.form.validate() || overComment) {
      this.isMultiple = false
      return true
    }
  }

  async sendDirectSale (changeSaleOrderStatus = false) {
    const pendingValidations = this.saleOrder.formValidation
      .filter(validation => validation.value === ValidationStatus.PENDING && this.shouldValidateField(validation.name.toLowerCase(), this.formData))

    const needsCorrectionValidations = this.saleOrder.formValidation
      .filter(validation => validation.value === ValidationStatus.NEED_CORRECTION)

    if (pendingValidations.length || needsCorrectionValidations.length) {
      let message = 'No se puede cambiar el estado porque:'

      if (pendingValidations.length) {
        message += `\nFaltan los siguientes campos requeridos:\n${pendingValidations.map(v => `- ${v.name}`).join('\n')}`
      }

      if (needsCorrectionValidations.length) {
        message += `\nLos siguientes campos necesitan corrección:\n${needsCorrectionValidations.map(v => `- ${v.name}`).join('\n')}`
      }
      console.log('message', message)
    } else {
      console.log('Cambiando estado: Todo está correcto')
    }
    this.loadingForm = true
    await this.sendDirectSaleOrder(this, changeSaleOrderStatus)
    await this.close()
  }

  @Debounce(500)
  async send () {
    if (this.isDirectSale) {
      return this.sendDirectSale(this.changeSaleOrderStatus)
    }

    if (this.validateFields()) {
      await this.setFieldError()
      return
    }

    const { saleOrder } = this

    this.loadingForm = true

    if (!saleOrder.status.isToUpdating) {
      await this.handleSaleOrder(this)
    } else {
      await this.handleSaleOrderUpdating(this)
    }

    await this.addUpdateDiscount()

    await this.updateSaleOrderItems(saleOrder)

    this.loadingForm = false
    await this.close()
  }

  async updateSaleOrderItems (order) {
    const { deal: { stock } } = this

    if (!order?.saleOrderItems?.find(item => item.isProduct)) {
      await this.insertSalesOrderItemProduct(order.id, stock)
    }

    if (!order?.saleOrderItems?.find(item => item.isTransfer)) {
      await this.insertSalesOrderItemTransfer(order.id, stock)
    }
  }

  async addOrUpdateDiscountPostFinancing () {
    const { saleOrder, formData } = this
    if (!isValidNumber(formData.discountPostFinancing)) return

    const deal = saleOrder?.deal?.lead?.deals?.find(deal => deal.isSale)
    const pos = deal.saleOrders[0].saleOrderItems.findIndex(item => item.type.name === 'post_financing_discount')

    if (!pos || pos < 1) {
      const type = await this.fetchData({
        query: { name: 'find', model: 'ItemType' },
        filter: { name: { _eq: 'post_financing_discount' } },
      })
      await this.pushData({
        model: 'SaleOrderItem',
        fields: {
          amount: formData.discountPostFinancing,
          id_sale_order: saleOrder.id,
          quantity: 1,
          id_item_type: type[0]?.id,
        },
      })
    } else {
      const discountId = deal.saleOrders[0].saleOrderItems[pos].id
      await this.pushData({
        model: 'SaleOrderItem',
        fields: {
          id: discountId,
          amount: formData.discountPostFinancing,
        },
      })
    }
  }

  async addUpdateDiscount () {
    const { saleOrderItemDiscountId, formData, discountIsPending } = this

    if (discountIsPending) {
      await this.addOrUpdateDiscountPostFinancing()
      return
    }

    if (saleOrderItemDiscountId && isValidNumber(formData.discount)) {
      await this.pushData({
        model: 'SaleOrderItem',
        fields: {
          id: saleOrderItemDiscountId,
          amount: formData.discount,
        },
      })
    } else if (isValidNumber(formData.discount)) {
      const discountType = await this.fetchData({
        query: { name: 'find', model: 'ItemType' },
        filter: { name: { _eq: 'discount' } },
      })
      await this.pushData({
        model: 'SaleOrderItem',
        fields: {
          amount: formData.discount,
          id_sale_order: this.saleOrder.id,
          quantity: 1,
          id_item_type: discountType[0]?.id,
        },
      })
    }
  }

  get isSupervisor () {
    const { $route } = this

    return $route.fullPath.includes('supervisor')
  }

  get change () {
    const { formData, panels, section } = this

    return stringifySafe([formData, panels, section])
  }

  async searchPerson ({ input, type }) {
    if (!input?.length || input?.length < 2) return null

    const { saleMetadata } = this

    if (!saleMetadata) return null
    const { fields } = saleMetadata as Form

    if (!fields?.client) return
    const query = updateNestedObject(fields.client.computed.queries.items.where, '_eq', this.replaceSpace(input), ['name_person_type'])

    const persons = await this.findPersonSearch(query)

    if (type === 'acquirer') {
      this.fields.acquirer.items = persons
    } else {
      const ids = this.formData.acquirer?.map(acquirer => acquirer.id)
      this.fields.signers.items = persons.filter(person => !ids.includes(person.id))
    }
  }

  async editPerson (person) {
    const { backup, formData, panels } = this

    if (!backup) {
      this.setBackup({
        saleForm: formData,
      })
    } else {
      backup.saleForm = { ...formData, panels }
      this.setBackup(backup)
    }

    await this.$router.push({ name: 'generic-person-nested', params: { model: 'SaleOrder', uid: null, id: person.id } })
  }

  async goPerson (type) {
    const { backup, formData, panels } = this

    if (!backup) {
      this.setBackup({ saleForm: formData })
    } else {
      backup.naturalForm = null
      backup.saleForm = { ...formData, panels }
      this.setBackup(backup)
    }
    const idPerson = this.formData[type]?.id
    await this.$router.push({ name: 'generic-person-nested', params: { model: 'SaleOrder', uid: null, id: idPerson } })
  }

  setProperties (fileInfo, fileTypeName, fieldKey) {
    if (!fileInfo?.length) return
    const info = fileInfo.find(fileParameter => fileParameter.name === fileTypeName)
    if (info) {
      this.fields[fieldKey].properties.accept = info.fileType.mimes
      this.fields[fieldKey].properties.multiple = info.multiple
      this.fields[fieldKey].properties.fileTypeId = info.fileType.id
      this.fields[fieldKey].properties.name = info.name
      this.fields[fieldKey].properties.label = info.description
      this.fields[fieldKey].properties.required = info.required
      this.fields[fieldKey].properties.icon = info.fileType.icon
    }
  }

  loadingFile (flag) {
    this.isUploadingFile = flag
  }

  get bindClient () {
    const { fields: { client } } = this

    if (!client) return {}

    return { ...client.properties, items: client.items }
  }

  get discountIsPending () {
    const { saleOrder } = this

    if (!saleOrder) return false

    const { deal } = saleOrder

    if (!deal) return false

    const { lead: { sale } } = deal

    if (!sale) return false
    const { financial } = sale
    if (!financial) return false
    const { evaluation } = financial

    return Boolean(evaluation)
  }

  get discount () {
    const { lead: { sale } } = this
    if (!sale) return 0
    const { stock } = sale

    return stock?.price?.bonus?.amount || stock?.price?.margin || 0
  }

  get paymentError () {
    const { minValue, formData: { order }, totalPercentagePaid } = this
    this.disableSend = false
    if (Number(totalPercentagePaid) > 100) {
      this.disableSend = true
      return 'La suma de los pagos no puede ser mayor al total a cancelar'
    }

    if (!order) {
      this.disableSend = false
      return ''
    }

    const message = this.paymentValid(order) ? '' : `La suma de los pagos debe ser mayor ${fixPrice(minValue)}`

    if (message?.length) {
      this.disableSend = true
    }
    return message
  }

  paymentValid (payments) {
    const { minValue } = this
    const suma: number = payments.reduce((total, item) => {
      return total + Number(item.amount)
    }, 0)

    return suma >= minValue
  }

  setLeadInfo (lead, discount) {
    const { client, sale: { order: { discountPostFinancing } } } = lead as Lead

    if (discount?.value) {
      this.formData.discount = discount?.value
    }

    if (discountPostFinancing?.value) {
      this.formData.discountPostFinancing = discountPostFinancing.value
    }

    this.formData.client = client
    this.fields.client.items = [client]
  }

  async goToOrder () {
    const { saleOrder } = this
    if (this.backup?.paymentForm) {
      this.backup.paymentForm = null
      this.backup.client = null
    }
    this.saveBackup()

    const idDeal = saleOrder?.deal?.id ? saleOrder?.deal?.id.toString() : 'create'
    await this.$router.push({
      name: 'generic-payment',
      params: { parentModel: 'Deal', parentId: idDeal, id: 'create' },
    })
  }

  isNotReserve (payment) {
    return this.idProcess === payment?.idProcess
  }

  get bindInsurance () {
    const { fields: { insurance } } = this

    if (!insurance) return {}

    return { ...insurance.properties, items: insurance.items }
  }

  get bindBrokers () {
    const { fields: { brokers } } = this

    if (!brokers) return {}
    brokers.items.unshift(plainToInstance(Person, { id: null, alias: 'Ninguna' }))

    return { ...brokers.properties, items: brokers.items }
  }

  get bindDeductible () {
    const { fields: { deductible } } = this

    if (!deductible) return {}

    return { ...deductible.properties, items: deductible.items }
  }

  get bindWarranty () {
    const { fields: { warranties } } = this

    if (!warranties) return {}

    return { ...warranties.properties, items: warranties.items }
  }

  get bindSigners () {
    const { fields: { signers } } = this

    if (!signers) return {}

    return { ...signers.properties, items: signers.items }
  }

  get bindAcquirer () {
    const { fields: { acquirer } } = this

    if (!acquirer) return {}

    return { ...acquirer.properties, items: acquirer.items }
  }

  get disabled () {
    return false
  }

  get isDigitalContract () {
    const { formData: { documentType }, documentFilesParameters } = this
    if (!documentType) return false

    const file = documentFilesParameters.find(file => file.name === `buyer_${documentType.name}` || file.name === documentType.name)

    if (file) {
      this.setFileProperties('contract', file)
    } else {
      this.filesProperties.contract = { name: null }
    }
    this.setFileProperties('contract', file)
    return documentType?.name === 'digital_contract'
  }

  get isInvoice () {
    const { formData: { documentType } } = this
    const isInvoice = documentType?.name.includes('invoice')

    this.fields.linkContract.properties.required = !isInvoice

    return isInvoice
  }

  get discountAuthorized () {
    const { saleOrder, formData: { discountPostFinancing, discount: discountForm } } = this

    if (!saleOrder) return 0

    const discount = Number(discountPostFinancing) || Number(saleOrder?.discountPostFinancing?.value) || 0

    return (Number(discount) + Number(discountForm || 0))
  }

  get priceList () {
    const { saleOrder } = this

    if (!saleOrder) return 0

    return saleOrder?.product?.amount || saleOrder?.deal?.stock?.price?.amount || 0
  }

  get totalPaymentsPaid () {
    const { formData: { order } } = this

    if (!order?.length) return 0

    return order.reduce((total, item) => total + Number(item.amount), 0)
  }

  get totalPaymentsValidated () {
    const { formData: { order } } = this

    if (!order?.length) return 0

    return order.filter(item => (item.status.isClosed && item.closingReason.successful) || item?.status?.isPendingPayment).reduce((total, item) => total + Number(item.amount), 0)
  }

  get financedAmount () {
    const { saleOrder } = this

    const evaluation = saleOrder?.financings?.[0]?.evaluations.find(evaluation => evaluation.isApproved)

    let financedAmount = 0
    if (evaluation) {
      financedAmount = saleOrder?.financings?.[0].requestAmount
    }

    return financedAmount
  }

  get hasFinancing () {
    const { saleOrder } = this

    const evaluation = saleOrder?.financings?.[0]?.evaluations.find(evaluation => evaluation?.status?.isApproved || evaluation?.closingReason?.isSigned)

    const hasTransfer = saleOrder?.financings?.[0]?.financedItems?.find(item => item.saleOrderItem?.type?.name === 'transfer')

    return Boolean(evaluation) && hasTransfer
  }

  get total () {
    const { totalPaymentsPaid, totalAmount } = this

    return totalAmount - totalPaymentsPaid
  }

  get totalValid () {
    const { totalPaymentsValidated, totalAmount } = this

    return totalAmount - totalPaymentsValidated
  }

  get totalAmount () {
    const {
      discountAuthorized: discount,
      priceList,
      formData: {
        transferCost,
      },
      warrantyAmount,
      warrantyAmountSet,
      formData,
    } = this

    const calculatedDiscount = (Number(discount) || Number(formData?.discount || 0))

    return priceList + (Number(transferCost) || 0) + (warrantyAmountSet || warrantyAmount || 0) - (calculatedDiscount || 0)
  }

  get saleOrderHasInterveners () {
    return Boolean(this.saleOrder?.deal?.stock?.acquirer?.length) || Boolean(this.saleOrder.document?.acquirers?.length)
  }

  get stock () {
    return this.saleOrder?.deal?.stock
  }

  @Watch('formData.signers', { immediate: true, deep: true })
  onSignersChange (val: Person[]) {
    if (!val?.length) {
      this.errorSignerMessages = ''
      return
    }

    this.validatePersonInfo(val, 'firmante', 'errorSignerMessages')
  }

  async validatePersonInfo (persons, type, field) {
    let error = false
    for (const person of persons) {
      const address = await this.fetchData({
        query: { name: 'find', model: 'PersonAddress' },
        filter: { id_person: { _eq: person.id } },
        force: true,
      })

      if (!person?.uid && !error) {
        error = true
        this[field] = `El ${type} ${person.fullName} no tiene un RUT asociado`
      }

      if (!address?.length && !error) {
        error = true
        this[field] = `El ${type} ${person.fullName} no tiene una dirección asociada`
      }
    }

    if (!error) {
      this[field] = ''
    }
  }

  @Watch('formData.acquirer', { immediate: true, deep: true })
  onAcquirerChange (val: Person[]) {
    if (!val?.length) {
      this.errorAcquirerMessages = ''
      return
    }

    this.validatePersonInfo(val, 'adquiriente', 'errorAcquirerMessages')
  }

  get warrantyChange () {
    const { formData: { warranty }, loaded } = this

    return {
      warranty,
      loaded,
    }
  }

  @Watch('warrantyChange', { immediate: true, deep: true })
  async onWarrantyChange (val: any) {
    const warranty = this.fields.warranties.items.find(warranty => warranty.id === val.warranty?.id)

    if (warranty) {
      this.warrantyAmount = await this.getCurrencyValueExchange(warranty?.quotas?.[0], this.currency)
    } else {
      this.warrantyAmount = undefined
    }

    this.setDetails()
  }

  get saleOrderToContract () {
    const { saleOrder, isToUpdatingAndIsContract } = this
    this.panels = [3]

    return saleOrder?.status?.isToContract || isToUpdatingAndIsContract
  }

  get isToUpdating () {
    const { saleOrder } = this

    return saleOrder?.status?.isToUpdating
  }

  get isToUpdatingAndIsContract () {
    const { saleOrder, formData } = this

    return saleOrder?.status?.isToUpdating && Boolean(formData.fileCav?.length)
  }

  get saleOrderToLegalReview () {
    const { saleOrder } = this

    return saleOrder?.status?.isLegalReview
  }

  get saleIsApproved () {
    const { saleOrder } = this

    return saleOrder?.status?.isApproved
  }

  get saleClosing () {
    const { saleOrder } = this

    return saleOrder?.closingReason?.name === 'successful'
  }

  get saleOrderToUpdateTransfer () {
    const { saleOrder, formData: { fileCav } } = this
    return (saleOrder?.status?.isToUpdating || saleOrder?.status?.isToConfirm) && Boolean(fileCav.length)
  }

  async editPayment (item) {
    this.saveBackup()

    if (this.isSupervisor) {
      await this.$router.push({
        name: 'generic-payment-supervisor',
        params: { uid: item.id },
      })
    } else {
      await this.$router.push({
        name: 'generic-payment',
        params: { uid: item.id },
      })
    }
  }

  get totalPercentagePaid () {
    const { totalAmount, totalPaymentsPaid } = this

    return ((totalPaymentsPaid * 100) / totalAmount).toFixed(2)
  }

  get totalPercentageValidate () {
    const { totalPaymentsPaid, totalPaymentsValidated } = this

    return ((totalPaymentsValidated * 100) / totalPaymentsPaid).toFixed(2)
  }

  get discountChange () {
    const { formData: { discount }, loaded, deal } = this

    return {
      discount,
      loaded,
      deal,
    }
  }

  get discountPostFinancingChange () {
    const { formData: { discountPostFinancing, discount }, loaded, deal } = this

    return {
      discountPostFinancing,
      discount,
      loaded,
      deal,
    }
  }

  @Watch('discountPostFinancingChange', { immediate: true, deep: true })
  @Debounce(500)
  onDiscountChange (val) {
    const max = val?.deal?.lead?.sale?.stock?.price?.bonuses?.[0]?.amount || val?.deal?.lead?.sale?.stock?.currentPrice?.margin

    const discount = Number(val.discountPostFinancing) + Number(val.discount)

    if (val.discountPostFinancing) {
      if (discount > Number(max)) {
        this.errorDiscountPostFinancing = `El descuento no puede ser mayor al autorizado ${fixPrice(max)}`
      } else {
        this.errorDiscountPostFinancing = ''
      }
    } else {
      if (discount > Number(max)) {
        this.errorDiscount = `El descuento no puede ser mayor al autorizado ${fixPrice(max)}`
      } else {
        this.errorDiscount = ''
      }
    }

    this.setDetails()
  }

  get signers () {
    const { formData: { signers, acquirer } } = this

    if (!signers?.length) return acquirer || []

    return signers
  }

  get saleOrderIsToConfirm () {
    const { saleOrder } = this
    return saleOrder?.status?.isToConfirm
  }

  getIcon (item) {
    if (item?.closingReason?.name === 'successful') {
      return 'mdi-eye'
    }
    return 'mdi-pencil-outline'
  }

  @Watch('formData', { immediate: true, deep: true })
  @Debounce(200)
  onFormDataChange (val) {
    const fields = ['fileCav', 'filePenalties', 'fileLegalReport']
    const { ids, fieldsWithIds } = this.processFields(fields, val)

    this.checkForDuplicates(ids, fieldsWithIds)

    this.checkStepper(val)
  }

  @Debounce(500)
  checkStepper (values) {
    const validation: FormValidationItem[] = []

    // Validar campos simples
    this.getSimpleFields().forEach(field => {
      const validationResult = this.validateSimpleField(field, field.name, values)
      validation.push({
        ...validationResult,
        section: field.section,
        order: field.order,
      })
    })

    // Validar archivos
    this.getFileFields().forEach(field => {
      const validationResult = this.validateFileField(field, field.name, values)
      validation.push({
        ...validationResult,
        section: field.section,
        order: field.order,
      })
    })

    // Validar enlaces
    this.getLinkFields().forEach(field => {
      const validationResult = this.validateLinkField(field, field.name, values)
      validation.push({
        ...validationResult,
        section: field.section,
        order: field.order,
      })
    })

    this.saleOrder.formValidation = validation
  }

  checkForDuplicates (ids, fieldsWithIds) {
    for (const id in ids) {
      if (ids[id] > 1) {
        for (const field of fieldsWithIds[id]) {
          this.$refs[field].errorMessage = 'El archivo está duplicado'
        }
      }
    }
  }

  processFields (fields, val) {
    const ids = {}
    const fieldsWithIds = {}

    for (const field of fields) {
      if (this.$refs[field] && this.$refs[field].errorMessage === 'El archivo está duplicado') {
        this.$refs[field].errorMessage = ''
      }
      const id = this.isArrayFiles(val[field]) ? val[field][0]?.id : val[field]?.[0]?.file?.id
      if (id) {
        const parsedId = parseToNumber(id)
        ids[parsedId] = (ids[parsedId] || 0) + 1
        if (!fieldsWithIds[parsedId]) {
          fieldsWithIds[parsedId] = []
        }
        fieldsWithIds[parsedId].push(field)
      }
    }

    return { ids, fieldsWithIds }
  }

  get withWarranty () {
    const { formData: { warranty } } = this

    return Boolean(warranty?.id)
  }

  @Watch('formData.client', { immediate: true, deep: true })
  async onClientChange (val) {
    if (!val?.id) return
    const person = await this.fetchData({
      query: { name: 'fetch', model: 'Person', params: { id: val.id } },
      force: true,
    })

    const errors = nameAlert(person)
    if (!person?.uid) {
      errors.push('El rut es obligatorio para crear la venta')
      this.rutError = errors.join(', ')
    } else if (errors.length) {
      this.rutError = errors.join(', ')
    } else {
      this.rutError = ''
    }
  }

  get isClosed () {
    const { saleOrder } = this

    return Boolean(saleOrder?.closingReason?.id)
  }

  @Watch('formData.transferCost', { immediate: true })
  onTransferCostChange () {
    if (this.loadingForm) return
    this.setDetails()
  }

  get messageToContract () {
    const { withWarranty, formData, totalPercentageValidate, totalPercentagePaid, saleOrder } = this
    if (saleOrder?.status?.isToContract) return false

    return !withWarranty && !formData.isTag && totalPercentageValidate === '100.00' && totalPercentagePaid === '100.00'
  }

  private validateDependencies (field: any, values: any): boolean {
    if (!field.dependsOn) return true

    const dependencies = {
      warranty: () => !values.warranty?.id,
      isWarranty: () => !values.isWarranty,
      isTag: () => !values.isTag,
      paymentsValidated: () => this.totalPaymentsValidated !== '100.00',
    }

    return !dependencies[field.dependsOn]?.()
  }

  private getFieldValidationStatus (fieldValue: any, hasError: boolean, isRequired: boolean, fieldName: string, field: string): ValidationStatus {
    // Caso especial para el campo warranty que siempre tiene valor por defecto
    if (field === 'warranty') {
      // Verificar si realmente tiene un ID válido seleccionado
      if (!fieldValue?.warrantyDescription?.length && isRequired) {
        return ValidationStatus.PENDING
      }
      return ValidationStatus.OK
    }

    if (!isRequired) {
      return fieldValue ? ValidationStatus.OK : ValidationStatus.OPTIONAL
    }

    if (hasError) {
      return ValidationStatus.NEED_CORRECTION
    }

    if (!fieldValue) {
      return ValidationStatus.PENDING
    }

    if (Array.isArray(fieldValue)) {
      return fieldValue.length ? ValidationStatus.OK : ValidationStatus.PENDING
    }

    if (typeof fieldValue === 'boolean') {
      // Los valores booleanos (true o false) son considerados como valores válidos
      return ValidationStatus.OK
    }

    return ValidationStatus.OK
  }

  validateSimpleField (field, name, values) {
    if (!this.validateDependencies(field, values) || !this.shouldValidateField(field.field, values)) {
      return {
        value: ValidationStatus.OPTIONAL,
        name: field.name,
        link: null,
      }
    }

    if (field.field === 'order') {
      return {
        value: this.totalPercentageValidate === '100.00' && this.totalPercentageValidate === this.totalPercentagePaid ? ValidationStatus.OK : ValidationStatus.PENDING,
        name: field.name,
        link: null,
      }
    }

    const fieldValue = values[field.field]
    const hasError = this.$refs[field.field]?.errorMessage?.length

    // Caso especial para el cliente - verificar también rutError
    if (field.field === 'client' && this.rutError && this.rutError.length > 0) {
      return {
        value: ValidationStatus.NEED_CORRECTION,
        name: field.name,
        link: null,
      }
    }

    // Si es un campo booleano como isWarranty o isTag, consideramos que siempre tiene un valor válido si está definido
    if ((field.field === 'isWarranty' || field.field === 'isTag') && fieldValue !== null && fieldValue !== undefined) {
      return {
        value: ValidationStatus.OK,
        name: field.name,
        link: null,
      }
    }

    return {
      value: this.getFieldValidationStatus(fieldValue, hasError, field.required, field.name, field.field),
      name: field.name,
      link: null,
    }
  }

  validateFileField (field, name, values) {
    // Verificar si el campo debe ser validado
    if (!this.shouldValidateField(field.field, values)) {
      return { value: ValidationStatus.OPTIONAL, name: field.name, link: null }
    }

    const files = values[field.field] || []
    const hasError = this.$refs[field.field]?.errorMessage?.length

    // Si el campo es requerido y no hay archivos, retornar PENDING
    if (field.required && !files.length) {
      return { value: ValidationStatus.PENDING, name: field.name, link: null }
    }

    // Si hay error en el campo, retornar NEED_CORRECTION
    if (hasError) {
      return { value: ValidationStatus.NEED_CORRECTION, name: field.name, link: null }
    }

    // Si hay archivos y no hay errores, retornar OK
    if (files.length) {
      return {
        value: ValidationStatus.OK,
        name: field.name,
        link: files.length === 1 ? files[0]?.link : files.map(file => file?.link),
      }
    }

    // Si no es requerido y no hay archivos, retornar OPTIONAL
    return { value: ValidationStatus.OPTIONAL, name: field.name, link: null }
  }

  shouldValidateField (field, values) {
    switch (field) {
      // Campos de garantía y seguros
      case 'insurance':
      case 'broker':
      case 'deductible':
      case 'cost':
        return values.isWarranty === true

      // Campos de Tag
      case 'fileTag':
        return values.isTag === true

      // Campos de garantía
      case 'fileWarranty':
      case 'fileExtraWarranty':
        return values.warranty?.id

      // Campo de descuento post financiamiento
      case 'discountPostFinancing':
        return this.discountIsPending

      // Campo de enlace de contrato
      case 'linkContract':
        return (this.isDirectSale || this.totalPaymentsValidated === '100.00') && (this.isDigitalContract || this.isInvoice)

      // Campos de contrato
      case 'fileCav':
      case 'filePenalties':
      case 'fileLegalReport':
      case 'fileLicense':
      case 'linkLegalReport':
      case 'saleOrderSigned':
        return this.isDirectSale || this.totalPaymentsValidated === '100.00'

      default:
        return true
    }
  }

  getSimpleFields () {
    const fields = [
      // Sección General
      { field: 'client', name: 'Cliente', order: 1, section: 'General', required: true },
      { field: 'observation', name: 'Observación', order: 99, section: 'Adicionales' },

      // Sección Descuentos y Costos
      { field: 'transferCost', name: 'Traspaso', order: 3, section: 'Descuentos y Costos' },
      { field: 'discount', name: 'Descuento otorgado', order: 4, section: 'Descuentos y Costos' },
      { field: 'warranty', name: 'Garantía', order: 5, section: 'Descuentos y Costos', required: true },
      { field: 'comment', name: 'Comentario de garantía postventa', order: 6, section: 'Descuentos y Costos' },

      // Sección Abonos
      { field: 'order', name: 'Abonos', order: 7, section: 'Abonos', required: true },

      // Sección Condiciones de Entrega
      { field: 'isWarranty', name: 'Asegurado', order: 8, section: 'Condiciones de Entrega', required: true },
      { field: 'isTag', name: 'Requiere Tag', order: 13, section: 'Condiciones de Entrega', required: true },
    ]

    // Solo incluir campos de seguros si isWarranty es true
    if (this.formData.isWarranty) {
      fields.push(
        { field: 'broker', name: 'Corredora de seguros', order: 9, section: 'Condiciones de Entrega', required: true },
        { field: 'insurance', name: 'Compañía de seguros', order: 10, section: 'Condiciones de Entrega', required: true },
        { field: 'deductible', name: 'Deducible', order: 11, section: 'Condiciones de Entrega', required: true },
        { field: 'cost', name: 'Costo Prima', order: 12, section: 'Condiciones de Entrega', required: true }
      )
    }

    if (this.formData.acquirer?.id || this.formData?.signers?.id) {
      fields.push({ field: 'signers', name: 'Firmantes', order: 14.7, section: 'Contrato', required: true })
    }

    // Sección Contrato
    if (this.isDirectSale || this.totalPaymentsValidated === '100.00') {
      fields.push(
        { field: 'acquirer', name: 'Adquiriente', order: 14.5, section: 'Contrato', required: true },
        { field: 'purchaseRepresentative', name: 'Representante de Compra', order: 14.6, section: 'Contrato' },
        { field: 'documentType', name: 'Tipo Documento', order: 16, section: 'Contrato', required: true },
        { field: 'contract', name: 'Contrato', order: 17, section: 'Contrato', required: true }
      )
    }

    // Solo incluir discountPostFinancing si discountIsPending es true
    if (this.discountIsPending) {
      fields.splice(4, 0, {
        field: 'discountPostFinancing',
        name: 'Descuento Post Financiamiento',
        order: 4.5,
        section: 'Descuentos y Costos',
        required: false,
      })
    }

    return fields.sort((a, b) => a.order - b.order)
  }

  getFileFields () {
    const fields = []

    if (this.withWarranty) {
      fields.push(
        { field: 'fileWarranty', name: 'Archivo Garantía', order: 8.1, section: 'Condiciones de Entrega', dependsOn: 'warranty', required: true },
        { field: 'fileExtraWarranty', name: 'Archivo Garantía Extra', order: 8.2, section: 'Condiciones de Entrega', dependsOn: 'warranty', required: true },
      )
    }

    if (this.formData.isTag) {
      fields.push(
        { field: 'fileTag', name: 'Carta Tag', order: 13.1, section: 'Condiciones de Entrega', dependsOn: 'isTag' },
      )
    }

    return [
      // Sección Condiciones de Entrega
      ...fields,
      // Sección Contrato
      { field: 'fileCav', name: 'Cav', order: 14.1, section: 'Contrato', dependsOn: 'paymentsValidated', required: true },
      { field: 'filePenalties', name: 'Certificado de Multas actualizado', order: 14.2, section: 'Contrato', dependsOn: 'paymentsValidated', required: true },
      { field: 'fileLegalReport', name: 'Informe Legal', order: 14.3, section: 'Contrato', dependsOn: 'paymentsValidated', required: true },
      { field: 'fileLicense', name: 'Carnet del firmante', order: 14.7, section: 'Contrato', dependsOn: 'paymentsValidated' },
      { field: 'saleOrderSigned', name: 'Nota de venta firmada', order: 18, section: 'Contrato', dependsOn: 'paymentsValidated', required: true },
    ].sort((a, b) => a.order - b.order)
  }

  getLinkFields () {
    return [
      { field: 'linkLegalReport', name: 'Enlace Informe Legal', order: 14.4, section: 'Contrato', dependsOn: 'paymentsValidated', required: true },
      { field: 'linkContract', name: 'Enlace Contrato', order: 14.6, section: 'Contrato', dependsOn: 'paymentsValidated', required: true },
    ].sort((a, b) => a.order - b.order)
  }

  validateLinkField (field, name, values) {
    if (!this.shouldValidateField(field.field, values)) {
      return {
        value: ValidationStatus.OPTIONAL,
        name: field.name,
        link: null,
      }
    }

    const url = values[field.field]
    const hasError = this.$refs[field.field]?.errorMessage?.length

    if (field.required && !url) {
      return {
        value: ValidationStatus.PENDING,
        name: field.name,
        link: null,
      }
    }

    if (hasError) {
      return {
        value: ValidationStatus.NEED_CORRECTION,
        name: field.name,
        link: null,
      }
    }

    if (url) {
      // Usamos la regla validUrl existente
      const isValid = this.validUrl.every(rule => rule(url) === true)
      return {
        value: isValid ? ValidationStatus.OK : ValidationStatus.NEED_CORRECTION,
        name: field.name,
        link: url,
      }
    }

    return {
      value: ValidationStatus.OPTIONAL,
      name: field.name,
      link: null,
    }
  }

  async downloadSaleOrderSigned () {
    this.loadingNote = true
    await this.sendDirectSaleOrder(this)

    this.$refs.salePDFCell.docHandler()
    this.$refs.salePDFCell.preview = true
    this.loadingNote = false
  }
  }
